module.exports = __webpack_public_path__ + "img/sb-img.b79c6282.png";